module.exports = "images/5ans.58a15d2b.png";